<ng-container *ngIf="isModalWindow">
  <sub-header [isModal]="true" [windowHash]="windowHash" [includeContextHelp]="true"></sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1" *ngIf="isProjectLoaded()">
    <ng-container *ngTemplateOutlet="CONTENT"></ng-container>
  </p-scrollPanel>
</ng-container>
<div class="wrapper wrapper-content" *ngIf="!isModalWindow&&isProjectLoaded()">
  <ng-container *ngTemplateOutlet="CONTENT"></ng-container>
</div>
<ng-template #CONTENT>
  <!--div class="row border-bottom" *ngIf="!isDossierLoaded()">
      <div class="col-lg-9">
        <h2>{{ 'Calendar.user.events' | translate }} {{ userFullName }}</h2>
      </div>
    </div-->
  <div class="row" *ngIf="isProjectLoaded()">
    <div class="col-md-3" *ngIf="showPanel">
      <!--
        div class="ibox-content">
        	<div *ngFor='let eventWeek of eventsWeek;  let i = index'>
        		<h2>Eventos de la semana</h2>
        		<ul class="list-group clear-list m-t">
                                  <li class="list-group-item fist-item">
                                     <span class="float-right">
                                        {{eventWeek.start|date:'dd-MM-yyyy HH:mm'}}
                                     </span>
                                     <span class="label label-success">{{i}}</span>  {{eventWeek.title}}
                                 </li>

                             </ul>
        	</div>
        </div
        [style]="{ 'margin-bottom': '20px' }"
      -->
      <p-panel [toggleable]=true>
        <p-header>
          <span class="m-xst">{{ 'Calendar.list' | translate }}</span>
          <span class="leyenda float-right">Total {{ this.events.length }}</span>
        </p-header>
        <div class="ibox-content">
          <div class="feed-activity-list">
            <div *ngFor="let event of events; let i = index">
              <div class="feed-element">
                <div class="pull-left d-inline mr-1" [ngSwitch]="event.type">
                  <div class="icon d-inline mr-1" *ngSwitchCase="'MCX'">
                    <i class="fa fa-address-card-o  fa-2x" aria-hidden="true"></i>
                  </div>
                  <div class="icon d-inline mr-1" *ngSwitchCase="'MCB'">
                    <i class="fa fa-calendar-minus-o fa-2x" aria-hidden="true"></i>
                  </div>
                  <div class="icon d-inline mr-1" *ngSwitchCase="'MCA'">
                    <i class="fa fa-calendar-o fa-2x" aria-hidden="true"></i>
                  </div>
                  <div class="icon d-inline mr-1" *ngSwitchDefault>
                    <i class="fa fa-calendar fa-2x" aria-hidden="true"></i>
                  </div>
                </div>
                <strong class="d-inline">{{ event.title }}</strong>
                <div class="media-body mt-2">
                  <small class="text-muted d-block overflow-auto" style="max-height: 150px;">{{ event.observations
                    }}</small>
                  <br />
                  <small class="text-muted">{{ event.start | date: DATEPIPE_DATETIME_FORMAT }}</small>
                </div>
              </div>
              <!--
                button class="btn btn-primary btn-block m-t"><i class="fa fa-arrow-down" aria-hidden="true" ></i> Show More</button
              -->
            </div>
          </div>
        </div>
      </p-panel>
      <!-- p-panel [toggleable]=true *ngIf="this.dossierId&&this.types" class="m-t-md">
          <p-header>
            <span class="m-xst">{{'Calendar.milestone.type'|translate}}</span>
          </p-header>
          <div class="row">
            <div *ngFor="let type of types; let i = index">
              <div class="col-12  m-b-sm" [ngSwitch]="type.identifier">
                <button class="btn btn-outline-secondary btn-xs-plyca " (click)="newEvent('new',this.type)"
                  *ngSwitchCase="'MCX'">
                  <i class="fa fa-address-card-o" aria-hidden="true"></i> {{ type.description?type.description:'--' }}
                </button>
                <button class="btn btn-outline-secondary btn-xs-plyca " (click)="newEvent('new',this.type)"
                  *ngSwitchCase="'MCB'">
                  <i class="fa fa-calendar-plus" aria-hidden="true"></i> {{ type.description?type.description:'--' }}
                </button>
                <button class="btn btn-outline-secondary btn-xs-plyca " (click)="newEvent('new',this.type)"
                  *ngSwitchCase="'MCA'">
                  <i class="fa fa-calendar-plus" aria-hidden="true"></i> {{ type.description?type.description:'--' }}
                </button>
                <button class="btn btn-outline-secondary btn-xs-plyca " (click)="newEvent('new',this.type)"
                  *ngSwitchDefault>
                  <i class="fa fa-calendar-plus" aria-hidden="true"></i> {{ type.description?type.description:'--' }}
                </button>
              </div>
            </div>
            <--
                button class="btn btn-primary btn-block m-t"><i class="fa fa-arrow-down" aria-hidden="true" ></i> Show More</button
            >
          </div>
        </p-panel-->
    </div>
    <div class="{{showPanel?'col-md-9':'col-md-12'}}" *ngIf="isProjectLoaded()">
      <p-fullCalendar #fc [events]="events" [options]="options"></p-fullCalendar>
    </div>
  </div>
</ng-template>